import api from './api';
import type { LegalTermsStatus } from '../types/auth';

/**
 * LGPD: aceite dos Termos de Uso e da Política de Privacidade vigentes (quem
 * entrou por Google/GitHub ou aceitou uma versão anterior) e a autorização,
 * opcional e revogável, de uso das imagens geradas em portfólio/marketing.
 */
export const legalService = {
  accept: async (marketingImagesConsent: boolean): Promise<LegalTermsStatus> => {
    const response = await api.post<{ data: LegalTermsStatus }>('/legal/accept', { acceptTerms: true, marketingImagesConsent });
    return response.data.data;
  },

  setMarketingImagesConsent: async (granted: boolean): Promise<LegalTermsStatus> => {
    const response = await api.put<{ data: LegalTermsStatus }>('/legal/marketing-images-consent', { granted });
    return response.data.data;
  },
};
